var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsFiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0C17.2614 0 19.5 2.23858 19.5 5V17C19.5 20.866 16.366 24 12.5 24C8.63401 24 5.5 20.866 5.5 17V9H7.5V17C7.5 19.7614 9.73858 22 12.5 22C15.2614 22 17.5 19.7614 17.5 17V5C17.5 3.34315 16.1569 2 14.5 2C12.8431 2 11.5 3.34315 11.5 5V17C11.5 17.5523 11.9477 18 12.5 18C13.0523 18 13.5 17.5523 13.5 17V6H15.5V17C15.5 18.6569 14.1569 20 12.5 20C10.8431 20 9.5 18.6569 9.5 17V5C9.5 2.23858 11.7386 0 14.5 0Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsFiles);
export default __webpack_public_path__ + "static/media/documents_files.da86934cb399d49d1022170b27207f3c.svg";
export { ForwardRef as ReactComponent };